<!--四宫格-->
<template>
  <table border="1" :class="{four:!highLight,'four-high-light':highLight}">
    <tr>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "FourSquares",
  props: {
    'highLight': {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">

$colorMain: #28CCCB;

table.four {
  border-collapse: collapse;

  > tr {
    > td {
      width: 6.3px;
      height: 6.3px;
    }
  }
}

table.four:hover {
  cursor: pointer;
  border-top: 1px solid $colorMain;
  border-left: 1px solid $colorMain;

  > tr {
    > td {
      border-bottom: 1px solid $colorMain;
      border-right: 1px solid $colorMain;
    }
  }
}

table.four-high-light {
  border-collapse: collapse;
  border-top: 1px solid $colorMain;
  border-left: 1px solid $colorMain;

  > tr {
    > td {
      width: 6.3px;
      height: 6.3px;
      border-bottom: 1px solid $colorMain;
      border-right: 1px solid $colorMain;
    }
  }
}

table.four-high-light:hover {
  cursor: pointer;
}

</style>
